export default "__VITE_ASSET__ce45fbb7__"